function normalizeCount(value) {
    const isIntegerString = typeof value === 'string' && /^-?\d+$/.test(value.trim());
    const count = typeof value === 'number' ? value : (isIntegerString ? Number(value) : Number.NaN);

    if (!Number.isSafeInteger(count)) {
        throw new TypeError('Ukrainian count must be a safe integer or an integer string.');
    }

    return Math.abs(count);
}

export function selectForm(value, one, few, many) {
    const count = normalizeCount(value);
    const mod10 = count % 10;
    const mod100 = count % 100;

    if (mod100 >= 11 && mod100 <= 14) {
        return many;
    }

    if (mod10 === 1) {
        return one;
    }

    if (mod10 >= 2 && mod10 <= 4) {
        return few;
    }

    return many;
}

export function formatCount(value, one, few, many) {
    const count = normalizeCount(value);

    return `${count} ${selectForm(count, one, few, many)}`;
}

export function formatBookCount(value) {
    return formatCount(value, 'книга', 'книги', 'книг');
}
